<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template #no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök status</em>
        </template>
        <template #option="{ id, label }">
            {{ label }}<span class="text-muted ml-1">({{ id }})</span>
        </template>
        <template #selected-option-container="{ option }">
            <div class="vs__selected w-100">
                <div class="w-100 badge" :class="['badge-' + option.color]">{{ option.label }}<span class="ml-1">({{ option.id }})</span></div>
            </div>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import BackendRepository from '@services/repositories/BackendRepository';

export default {
    name: 'CardOrderDeliveryStatusFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: null,
        };
    },
    async created() {
        this.options = await this.getOptions();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async getOptions() {
            let options = [];
            await BackendRepository.getCardOrderDeliveryStatuses().then((res) => {
                options = res;
            });

            return options;
        },
    },
};
</script>
